import en from "./locales/en-US.json";
import zh from "./locales/zh-CN.json";

export type Locale = "zh-CN" | "en-US";

export const defaultLocale: Locale = "en-US";

export const dictionaries = {
  "zh-CN": zh,
  "en-US": en
} as const;

export type Dictionary = typeof zh;

export function normalizeLocale(locale?: string | string[] | null): Locale {
  const value = Array.isArray(locale) ? locale[0] : locale;
  if (value === "zh-CN" || value === "en-US") return value;
  return defaultLocale;
}

export function getDictionary(locale?: string | string[] | null): Dictionary {
  return dictionaries[normalizeLocale(locale)];
}
